type Variant = 'default' | 'fullscreen' | 'canvas'

export function dashboardViewportClassName(variant: Variant) {
  const sizing = variant === 'default'
    ? 'min-h-dvh md:h-dvh md:min-h-0 md:overflow-hidden'
    : 'h-dvh min-h-0 overflow-hidden'
  return `bg-background text-sm flex flex-col md:flex-row ${sizing}`
}

export function dashboardContentOverflowClassName(variant: Variant, ownsViewport = false) {
  // Bound native absolute form controls to this frame; otherwise controls
  // inside a scrolling form can extend the document beyond its clipped page.
  const overflow = variant !== 'default' ? 'overflow-hidden'
    : ownsViewport ? 'md:overflow-hidden' : 'md:overflow-y-auto'
  return `relative min-h-0 ${overflow}`
}
